import React, { ReactNode } from 'react';
import { styled } from '@mui/material';
import { SIDEBAR_WIDTH } from 'constants/constants';
import Sidebar from 'components/sidebar/Sidebar';
import { useApp } from 'hooks/app';

interface MakeStylesProps {
  isopenedmenu: boolean;
}

const Container = styled('div')({
  display: 'flex',
  position: 'absolute',
  height: '100%',
  width: '100%',
});

const ContentWrapper = styled('div')<MakeStylesProps>(props => ({
  width: '100%',
  transition: 'all .3s cubic-bezier(0.4,0,0.2,1) 0ms!important',
  position: 'relative',
  overflowY: 'auto',
  paddingLeft: props.isopenedmenu ? SIDEBAR_WIDTH : 0,
  margin: '50px 0 0',
  [props.theme.breakpoints.down('md')]: {
    paddingLeft: 0,
  },
  '@media print': {
    padding: 0,
    margin: 0,
    overflowY: 'initial',
  },
}));

const Content = styled('div')<MakeStylesProps>(props => ({
  minHeight: 'calc(100vh - 50px)',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 30px',
  '@media print': {
    padding: 0,
  },
}));

const SidebarWrapper = styled('div')({
  position: 'fixed',
  height: '100%',
  zIndex: 1101,
});

interface DefaultLayoutProps {
  children: ReactNode;
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children }) => {
  const { isOpenedMenu } = useApp();

  return (
    <Container>
      <SidebarWrapper>
        <Sidebar />
      </SidebarWrapper>
      <ContentWrapper isopenedmenu={isOpenedMenu} id="content-wrapper">
        <Content isopenedmenu={isOpenedMenu} id="app-content">
          {children}
        </Content>
      </ContentWrapper>
    </Container>
  );
};

export default DefaultLayout;
